var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThirdOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FF5F14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 27.24C19.02 27.24 18.1867 27.08 17.44 26.76C16.6933 26.4267 16.0933 25.92 15.64 25.24C15.1867 24.56 14.9467 23.7067 14.92 22.68H17.44C17.4533 23.36 17.6733 23.9333 18.1 24.4C18.54 24.8533 19.1533 25.08 19.94 25.08C20.6867 25.08 21.26 24.8733 21.66 24.46C22.06 24.0467 22.26 23.5267 22.26 22.9C22.26 22.1667 21.9933 21.6133 21.46 21.24C20.94 20.8533 20.2667 20.66 19.44 20.66H18.4V18.56H19.46C20.14 18.56 20.7067 18.4 21.16 18.08C21.6133 17.76 21.84 17.2867 21.84 16.66C21.84 16.14 21.6667 15.7267 21.32 15.42C20.9867 15.1 20.52 14.94 19.92 14.94C19.2667 14.94 18.7533 15.1333 18.38 15.52C18.02 15.9067 17.82 16.38 17.78 16.94H15.28C15.3333 15.6467 15.78 14.6267 16.62 13.88C17.4733 13.1333 18.5733 12.76 19.92 12.76C20.88 12.76 21.6867 12.9333 22.34 13.28C23.0067 13.6133 23.5067 14.06 23.84 14.62C24.1867 15.18 24.36 15.8 24.36 16.48C24.36 17.2667 24.14 17.9333 23.7 18.48C23.2733 19.0133 22.74 19.3733 22.1 19.56C22.8867 19.72 23.5267 20.1067 24.02 20.72C24.5133 21.32 24.76 22.08 24.76 23C24.76 23.7733 24.5733 24.48 24.2 25.12C23.8267 25.76 23.28 26.2733 22.56 26.66C21.8533 27.0467 20.98 27.24 19.94 27.24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdOrange);
export default __webpack_public_path__ + "static/media/thirdOrange.ae0457e723c4f22da9561edc455ecef0.svg";
export { ForwardRef as ReactComponent };